import { MouseEvent, useState } from 'react';
import { Chip, Menu, MenuItem } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { useSelector } from 'react-redux';
import { Store } from 'src/redux/Store';
import { t } from 'src/lib/language';
import { FundraisingLanguages, FundraisingLanguagesList } from 'src/constants/FundraisingLanguages';

interface Props {
  disabled?: boolean;
  values: FundraisingLanguages[];
  onChange: (language: FundraisingLanguages) => void;
}
const ChipLanguageSelector = (props: Props) => {
  const {
    disabled, onChange, values,
  } = props;

  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);

  const openMenu = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorElement(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorElement(null);
  };

  const handleItemClick = (language: FundraisingLanguages) => {
    onChange(language);
    closeMenu();
  };

  const renderItem = () => {
    const list = FundraisingLanguagesList.filter(
      (language) => !values.includes(language),
    );
    return list.map((language: FundraisingLanguages) => (
      <MenuItem
        key={`language-menu-item-${language}`}
        value={language}
        onClick={() => handleItemClick(language)}>
        { t(lang, `forms.fundraising.${language}`) }
      </MenuItem>
    ));
  };
  if (values.length === FundraisingLanguagesList.length) {
    return (<></>);
  }

  return (
    <>
      <Chip
        style={{ marginLeft: '16px' }}
        color="primary"
        label="Add Language"
        disabled={disabled}
        onClick={openMenu}
        icon={<AddIcon />}
        key="chip-add-language" />
      <Menu
        anchorEl={anchorElement}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        id="customized-menu"
        getContentAnchorEl={null}
        keepMounted
        onClose={() => closeMenu()}
        open={!!anchorElement}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        key="chip-add-language-menu">
        {renderItem()}
      </Menu>
    </>
  );
};

export default ChipLanguageSelector;
